import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { autobind } from 'core-decorators'
import { observer } from 'mobx-react'
import { Link } from 'react-router'
import Logo from '../../base/components/Logo'
import Price from '../../base/components/Price'
import Icon from '../../../shared/components/Icon'
import ValueList from '../../shared/components/ValueList'
import createImageUrl from '../../shared/createImageUrl'
import getPath from '../../../shared/utils/getPath'
import FileList from '../../../shared/components/FileList'
import LoadingInfo from '../../../LoadingInfo'
import { imagesByType, toImageSet } from '../../../shared/utils/images'

@observer
export default
class MuseumDetails
  extends Component {

  static propTypes = {
    guidedTour: PropTypes.object.isRequired,
    museum: PropTypes.object.isRequired,
    params: PropTypes.shape({
      id: PropTypes.string.isRequired
    }),
    program: PropTypes.object.isRequired,
    router: PropTypes.object.isRequired,
  }

  @autobind
  handleGoBack() {
    this.props.router.goBack()
  }

  hasGoBackLink() {
    return !!this.props.router.goBack
  }

  renderOfferList() {

    const { museum, program, guidedTour } = this.props
    const museumId = museum.id

    const matches = [
      ...(program.filterCollection || [])
        .filter(prog => prog.museumId * 1 === museumId * 1),
      ...(guidedTour.filterCollection || [])
        .filter(tour => tour.museumId * 1 === museumId * 1)
    ]

    if (matches && matches.length) {
      return (
        <div className="row no-margin">

          {matches.map((itm) => {
            return (
              <div
                className={`col-md-3 col-xs-6 program ${itm.temporarilyNotBookable ? 'faded' : ''}`}
                key={`${itm.type}-${itm.id}`}
              >
                <Link to={getPath('frontend', itm.type, itm.id)}>
                  <span
                    className="banner"
                    style={{ backgroundImage: `url(${createImageUrl(itm.images[0], 600)})` }}
                  />
                </Link>
                <Link to={getPath('frontend', itm.type, itm.id)}>
                  {itm.title}
                </Link>
                {itm.temporarilyNotBookableReason ? (
                  <div className="faded-info" title={itm.temporarilyNotBookableReason}>
                    <Icon
                      name="virus-turquoise"
                      size="26"
                    />
                  </div>
                ) : null}
              </div>
            )
          })}

        </div>
      )
    }

    const loading = program.loading || guidedTour.loading

    return loading
      ? <LoadingInfo>Angebote werden geladen</LoadingInfo>
      : 'Keine Angebote'
  }

  render() {

    const entry = this.props.museum

    if (!entry) {
      return null
    }

    const { bannerImage, otherImages } = imagesByType(entry.images || [])

    return (
      <div className="row no-margin detail">

        <div className="col-md-4 col-sm-12">
          <div className="app-sidebar">
            <div className="clearfix">
              <Logo />

              {bannerImage
                ? (
                  <div className="banner-container">
                    <div className="banner"
                      style={{ backgroundImage: `url(${createImageUrl(bannerImage, 600)})` }}
                    />
                    {bannerImage.pivot && bannerImage.pivot.description
                      ? bannerImage.pivot.description
                      : null}
                  </div>
                )
                : null}

              {toImageSet(otherImages)
                .map(({ index, set }) => {
                  return (
                    <div key={index} className="other-images clearfix">
                      {set.map((image) => {
                        return (
                          <div key={image.url} className="small banner-container">
                            <div className="banner"
                              style={{ backgroundImage: `url(${createImageUrl(image, 600)})` }}
                            />
                            <div className="image-description">
                              {image.pivot && image.pivot.description
                                ? image.pivot.description
                                : null}
                            </div>
                          </div>
                        )
                      })}
                    </div>
                  )
                })}
            </div>

          </div>
        </div>

        <div className="col-md-8 col-sm-12">

          <h2>
            <Icon
              size={24}
              style={{ marginBottom: '-3px' }}
              name="house"
            />
            {entry.title}
          </h2>

          <div className="row action-bar">

            <div className="col-xs-12">
              {this.hasGoBackLink()
                ? (
                  <button
                    className="btn btn-small btn-primary"
                    onClick={this.handleGoBack}
                  >
                    <i className="glyphicon glyphicon-chevron-left" />
                    {' '}
                    Zurück
                  </button>
                ) : null}
            </div>

          </div>

          {entry.temporarilyNotBookable ? (
            <div className="row">
              <div className="col-xs-12 warn-block">
                <Icon
                  name="virus-turquoise"
                  size="26"
                />
                {entry.temporarilyNotBookableReason || 'Temporär nicht buchbar'}
              </div>
            </div>
          ) : null}

          <div className="row">

            <div className="col-md-6 col-sm-8 col-xs-12">

              <div className="row">

                <div className="col-xs-12">

                  <h4>Öffnungszeiten:</h4>
                  <pre>
                    {entry.openingHours}
                  </pre>

                  <h4>Informationen:</h4>

                  {entry.description}

                  <ul className="list-unstyled" />

                </div>

              </div>

            </div>

            <div className="col-md-3 col-sm-4 col-xs-12 ">

              <h4>Maßnahmen der Qualitätssicherung:</h4>
              <ValueList
                list={entry.qs}
                type="qs"
              />

              <h4>Ausstattung:</h4>
              <ValueList
                list={entry.equipments}
                type="equipment"
              />


            </div>

            <div className="col-md-3 col-sm-4 col-xs-12">

              <img
                alt="museum-map"
                src={`//maps.googleapis.com/maps/api/staticmap?center=${
                  entry.address.latitude
                },${
                  entry.address.longitude
                }&zoom=11&size=185x185&sensor=false&markers=color:blue%7Clabel:S|${
                  entry.address.latitude
                },${
                  entry.address.longitude
                }&key=AIzaSyDlmDlSiBiQXKCPyMWccIYxjkN5HJZvbTQ`}
              />
              <br />
              <br />
              {entry.address.street}
              {' '}
              {entry.address.number}
              <br />
              {entry.address.zip}{' '}
              {entry.address.location}
              <br />
              {(
                window.APP_CONFIG.list_region
                  .find(reg => reg.id === entry.address.region * 1) || {}
              ).title}
              <br />
              <br />
              Telefon:
              {' '}
              {entry.phone || '-'}
              <br />
              Fax:
              {' '}
              {entry.fax || '-'}
              <br />
              <a
                href={`mailto:${entry.email || '-'}`}
              >
                E-Mail-Kontakt
              </a>
              <br />
              <a
                href={entry.website}
                target="_blank"
                rel="noopener noreferrer"
              >
                Museumswebsite besuchen
              </a>

              {
                entry.drivingInstructions ?
                  (<div><h4>Anfahrt:</h4>
                    {entry.drivingInstructions}</div>)
                  : null
              }

              <h4>Eintritt:</h4>
              <Price value={entry.entryFeeAdults} />
              {' '}Erwachsene
              <br />
              <Price value={entry.entryFeePupils} />
              {' '}Schüler
              <br />
              <Price value={entry.entryFeeGroups} />
              {' '}Schulklassen (pro Schüler)
              <br />
              {entry.minGroupSize}
              {' '}Begleitpersonen kostenfrei
              <br />

              {entry.links ? (
                <div>
                  <h4>Links und Downloads:</h4>
                  <FileList
                    list={entry.links}
                    type="file"
                  />
                </div>
              ) : null}

            </div>
          </div>

          <div className="row no-margin">
            <h3>Museumspädagogische Angebote</h3>
            <div className="programs">
              {this.renderOfferList()}
            </div>
          </div>
        </div>

      </div>
    )
  }

}
// style={styles.map}
// {...locationProps}



// WEBPACK FOOTER //
// ./src/frontend/museum/components/Details.js